import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  TemplateRef,
  OnDestroy,
  NgZone,
} from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { Router, ActivatedRoute } from "@angular/router";
import { ITableColumnHeader } from "../../../models/table-column-header";
import { Subscription } from "rxjs";
import { ApiService } from "../../../providers/api.service";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { MatDialog } from "@angular/material/dialog";
import { BookingDetailsComponent } from "src/app/shared/components/booking-details/booking-details.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { TranslateService } from "@ngx-translate/core";
import { AddFutureBookingsComponent } from "src/app/shared/components/add-future-bookings/add-future-bookings.component";
import { InvoiceForReportComponent } from "src/app/shared/components/invoice-for-report/invoice-for-report.component";
import { YoutubeEmbedVideoComponent } from "../../new-v2-pages/new-v2-component/youtube-embed-video/youtube-embed-video.component";
import { CancelBookingNotesModalComponent } from "src/app/shared/components/cancel-booking-notes-modal/cancel-booking-notes-modal.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "src/app/services/notification.service";
import { CustomSnackbarComponent } from "src/app/shared/components/custom-snackbar/custom-snackbar.component";
import { AuthService } from "src/app/providers/auth.service";
import { DialogService } from "src/app/providers/dialog.service";
import { CreateNewBookingFromListComponent } from "src/app/shared/components/create-new-booking-from-list/create-new-booking-from-list.component";
import { AddJoiningInterestFromListComponent } from "../../new-v2-pages/new-v2-component/add-joining-interest-from-list/add-joining-interest-from-list.component";

@Component({
  selector: "sm-booking-history",
  templateUrl: "./booking-history.component.html",
  styleUrls: ["./booking-history.component.scss"],
})
export class BookingHistoryComponent implements OnInit, OnDestroy {
  isAccessForEmployeeInvoice: boolean = false
queryData:any = []
interestData:any = []
    discountInfo: any = null;
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  entityHashId: string = "";
  pageTitle: string = "Booking History";
  @Input() pageSubTitle: string = "";
  @Input() showBackButton: boolean = false;
  @Input("buttonText") showButton: string = "";
  @Input()
  headerCustomTemplate!: TemplateRef<any>;

  fromDate: any = new Date();
  toDate: any = new Date();
  messageList: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  displayedColumns: string[] = [
    "date",
    "customerName",
    "noOfServices",
    "cost",
    "paymentStatus",
    "startTime",
    "endTime",
    "assignedTo",
    "bookingType",
    "bookingStatus",
    "actions",
  ];
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.date"
      ),
      columnProperty: "bookingDate",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.customer_name"
      ),
      columnProperty: "customerName",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.services_count"
      ),
      columnProperty: "servicesCount",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.cost"
      ),
      columnProperty: "price",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.booking_status"
      ),
      columnProperty: "bookingStat",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.payment_status"
      ),
      columnProperty: "paymentStat",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.start_time"
      ),
      columnProperty: "bookingStartTime",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.end_time"
      ),
      columnProperty: "bookingEndTime",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.assigned_to"
      ),
      columnProperty: "employeeName",
    },
    {
      columnName: this.translateService.instant(
        "booking_history.column_headers.booking_type"
      ),
      columnProperty: "booking_type",
    },
  ];

  private _apiSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private _apiService: ApiService,
    private loaderservice: LoaderServiceService,
    public _modelRef: MatDialog,
    private messagingService: MessagingService,
    private dialogService:DialogService,
    private angularFireMessaging: AngularFireMessaging,
    private translateService: TranslateService,
    private _snackBar: MatSnackBar,
    private authService: AuthService,
    private notificationService: NotificationService,
    private zone: NgZone
  ) {
    this.listenForNewBookingUpdates();
    this.listenForBookingStatusUpdates();
    this.listenForBookingAssignmentUpdates();
    this._navService.hideSidebarAndNav = false;

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (resData.responseType === SM_CONSTANTS.GET_BOOKINGS_LIST_RESULT) {
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList = this.messageList.sort(
          (dataA: any, dataB: any) =>
            +new Date(dataB["bookingDate"]) - +new Date(dataA["bookingDate"])
        );
        // this.messageList = this.sortObjectsDescendingByBookingDate(this.messageList)
        this.messageList.forEach((element: any) => {
          if (element.customerInfo) {
            element.customerInfo = JSON.parse(element.customerInfo);
            element.customerName = element.customerInfo.name
              ? element.customerInfo.name
              : "New Customer";
            element.customerPhone = element.customerInfo.phone;
          }

          if (element.serviceInfo) {
            if (element.serviceInfo != null) {
              element.servicesCount = element.serviceInfo.length;
            }
          }

          if (element.custom_items) {
            if (element.custom_items != null) {
              element.custom_items =
                typeof element.custom_items == "string"
                  ? JSON.parse(element.custom_items)
                  : element.custom_items;
              element.customItemsArray = [];
              element.serviceInfo.forEach((item: any) => {
                element.customItemsArray.push(" " + item.item_name);
              });
            }
          }

          if (element.bookingType == 0) {
            element.booking_type = "Home service";
          } else if (element.bookingType == 1) {
            element.booking_type = "Shop service";
          } else if (element.bookingType == 2) {
            element.booking_type = "Virtual service";
          }

          if (element.paymentStatus === 0) {
            element.paymentStat = "Due";
          } else if (element.paymentStatus == 1) {
            element.paymentStat = "Done";
          } else if (element.paymentStatus == 2) {
            element.paymentStat = "Payment in progress";
          } else if (element.paymentStatus == 3) {
            element.paymentStat = "Error in payment";
          } else {
            element.paymentStat = "---";
          }

          // }

          if (element.bookingStartTime && element.bookingStartTime != null) {
            element.bookingStartTime = element.bookingStartTime.slice(0, 5);
          }
          if (element.bookingEndTime && element.bookingEndTime != null) {
            element.bookingEndTime = element.bookingEndTime.slice(0, 5);
          }

          if (
            element.bookingStatus == 0 ||
            element.bookingStatus == 1 ||
            element.bookingStatus == 2
          ) {
            element.bookingStat = "New booking";
          } else if (element.bookingStatus == 3) {
            element.bookingStat = "Under process";
          } else if (element.bookingStatus == 4) {
            element.bookingStat = "Completed";
          } else if (element.bookingStatus == 5) {
            element.bookingStat = "Booking confirmed";
          } else if (element.bookingStatus == 6) {
            element.bookingStat = "Cancelled by User";
          } else if (element.bookingStatus == 7) {
            element.bookingStat = "Assigned";
          } else if (element.bookingStatus == 8) {
            element.bookingStat = "Cancelled";
          } else if (element.bookingStatus == 9) {
            element.bookingStat = "Partially Complete";
          }

          const currentDate = new Date();
          const newDate = new Date(currentDate.toISOString().slice(0, 10));
          const bookingDate = new Date(element.bookingDate);
          console.log(bookingDate >= newDate);

          if (bookingDate >= newDate) {
            element.toshowOptions = 1;
          } else {
            element.toshowOptions = 0;
          }
        });

        console.log(this.messageList);

        this.loaderservice.showLoader = false;
        this.visible = true;
        this.loader = false
      }
       if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID
      ) {
        this.interestData = [];
        if (resData.result) {
          this.interestData = resData.result;
          console.log(this.interestData);

          this.interestData.forEach((element: any) => {
            element.request_services =
              typeof element.request_services == "string"
                ? JSON.parse(element.request_services)
                : element.request_services;
            element.custom_items =
              typeof element.custom_items == "string"
                ? JSON.parse(element.custom_items)
                : element.custom_items;
            element.products =
              typeof element.products == "string"
                ? JSON.parse(element.products)
                : element.products;
            element.request_timings =
              typeof element.request_timings == "string"
                ? JSON.parse(element.request_timings)
                : element.request_timings;
            element.phone =
              element.customer_country_code + " " + element.customer_phone;

            if (element.interest_type == 0) {
              element.service_mode = "Home service";
            } else if (element.interest_type == 1) {
              element.service_mode = "In-premise service";
            } else if (element.interest_type == 2) {
              element.service_mode = "Virtual service";
            }

            if (element.enrollment_request_status == 1) {
              element.item_status = "New";
            } else if (element.enrollment_request_status == 2) {
              element.item_status = "In progress";
            } else if (element.enrollment_request_status == 3) {
              element.item_status = "Marked as enrolled";
            } else if (element.enrollment_request_status == 4) {
              element.item_status = "Cancelled";
            } else if (element.enrollment_request_status == 5) {
              element.item_status = "Enrolled";
            }

            element.opted_services = element.request_services
              ? this.getServiceNames(element.request_services)
              : "";
            element.opted_timings = element.request_timings
              ? this.formatSchedule(element.request_timings)
              : "";
          });
        }

        this.loaderservice.showLoader = false;
        this.visible = true;
        this.loader = false
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_LIST
      ) {
        this.queryData = [];
        if (resData.result) {
          this.queryData = resData.result;
          console.log(this.queryData);

          this.queryData.forEach((element: any) => {
            element.phone = element?.country_code + " " + element.phone;
            element.email = element.email ?? "";

            if (element.service_mode == 0) {
              element.s_mode = "Home service";
            } else if (element.service_mode == 1) {
              element.s_mode = "In-premise service";
            } else if (element.service_mode == 2) {
              element.s_mode = "Virtual service";
            }

            if (element.status == 1) {
              element.item_status = "New";
            } else if (element.status == 2) {
              element.item_status = "In progress";
            } else if (element.status == 3) {
              element.item_status = "Resolved";
            } else {
              element.item_status = "---";
            }

            if (element.enquiry_type == 1) {
              element.e_type = "Booking";
            } else if (element.enquiry_type == 2) {
              element.e_type = "Membership";
            } else if (element.enquiry_type == 3) {
              element.e_type = "Payment";
            } else if (element.enquiry_type == 4) {
              element.e_type = "Feedback";
            } else if (element.enquiry_type == 5) {
              element.e_type = "Others";
            }
          });
        }
       
        this.loaderservice.showLoader = false;
        this.visible = true;
        this.loader = false
      }
      // if (
      //   resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS
      // ) {
      //   this._apiService.getBookingsList(
      //     this.entityHashId,
      //     this.formatDate1(this.fromDate),
      //     this.formatDate1(this.toDate)
      //   );
      // }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD
      ) {
        this._apiService.getBookingsList(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD
      ) {
        this._apiService.getBookingsList(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA
      ) {
        this._apiService.getBookingsList(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE
      ) {
        this._apiService.getBookingsList(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS
      ) {
        this._apiService.getBookingsList(
          this.entityHashId,
          this.formatDate1(this.fromDate),
          this.formatDate1(this.toDate)
        );
      }

       if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT
      ) {
        this.discountInfo = null;
        if (resData.result) {
          this.discountInfo = resData.result;
        }
           if (this.selectedValue == "1") {
          this._apiService.getBookingsList(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate)
          );
        } else if (this.selectedValue == "2") {
          this._apiService.getAllEnrollInterestByEntityId(
            this.entityHashId,
            "1",
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            this.pageNo.toString(),
            "4"
          );
        } else if (this.selectedValue == "3") {
          this._apiService.getEntityEnquiryList(
            this.entityHashId,
            this.formatDate1(this.fromDate),
            this.formatDate1(this.toDate),
            "3"
          );
        }
      }
    });
    if (
      !localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null ||
      localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == "null"
    ) {
      this.messagingService.requestPermission();
    }
    this.translateService.onLangChange.subscribe(() => {
      // Update your column headers when the language changes
      this.updateColumnHeaders();
    });
  }
  private updateColumnHeaders() {
    this.tableDisplayColumns.forEach((column, index) => {
      let data = [
        "date",
        "customer_name",
        "services_count",
        "cost",
        "booking_status",
        "payment_status",
        "start_time",
        "end_time",
        "assigned_to",
        "booking_type",
      ];
      // Update each column header with the translated value
      column.columnName = this.translateService.instant(
        `booking_history.column_headers.${data[index]}`
      );
    });
  }
  eph: string = "";
  isOwner: boolean = false;
  ngOnInit(): void {
    this.isOwner = this.authService.isOwner();
    // this.loader = true
    this.route.queryParams.subscribe((data) => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash;
      this.eph = data.eph;
    });
    this.toDate.setDate(this.fromDate.getDate() + 90);
 if(this.isOwner){
      this.isAccessForEmployeeInvoice = true;
    }else{

    const ssa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_SHOP_SERVICE_OPERATION_ACCESS);
    const hsa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_HOME_SERVICE_OPERATION_ACCESS);
    const vsa = sessionStorage.getItem(SM_CONSTANTS.EMPLOYEE_VIRTUAL_SERVICE_OPERATION_ACCESS);

    const bsss = sessionStorage.getItem('shop_service_status');
    const bhss = sessionStorage.getItem('home_service_status');
    const bvss = sessionStorage.getItem('virtual_service_status');



    // sessionStorage.getItem() returns a string or null.

    // 2. Check if ANY of the retrieved values is the string '1'
    if ((ssa == '1' && bsss != '2') || (hsa == '1' && bhss != '2') || (vsa == '1' && bvss != '2')) {
      this.isAccessForEmployeeInvoice = true;
    }
    }
    this.loaderservice.showLoader = true;
    this.visible = false;
    this.loader = true
       this._apiService.getBillDiscountData( 
          localStorage.getItem(
            SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID
          )
        );
  }
  createNotification(title: any, text: any) {
    const noti = new Notification(title, {
      body: text,
    });
  }
  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    if (this.newbookingsubscription) {
      this.newbookingsubscription.unsubscribe();
    }
    if (this.bookingAssignmentsubscription) {
      this.bookingAssignmentsubscription.unsubscribe();
    }
    if (this.bookingStatusUpdatedsubscription) {
      this.bookingStatusUpdatedsubscription.unsubscribe();
    }
  }

  navigate() {
    this.router.navigate(["../"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }
  search() {

    const fromDate = new Date(this.fromDate);
    const toDate = new Date(this.toDate);
    const maxRange = 90;
    const range =
      (toDate.getTime() - fromDate.getTime()) / (1000 * 3600 * 24);
      console.log(range);
      
    if (parseInt(range.toString()) > maxRange) {
      const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
        data: {
          title: "Alert",
          message:
            "The selected time frame between from date and to date should be under 90 days.",
          okbtn: "Ok",
          cancelbtn: "Cancel",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      return;
    }



    console.log(this.fromDate);
    console.log(this.entityHashId);
    console.log(this.toDate);
    this.loaderservice.showLoader = true;
    this.visible = false;
   if (this.selectedValue == "1") {
      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    } else if (this.selectedValue == "2") {

      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    } else if (this.selectedValue == "3") {
      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    }
  }

  getDateDiffrence(from: any, to: any) {
    from = new Date(from);
    to = new Date(to);
    const diffDays = Math.ceil(
      (from.valueOf() - to.valueOf()) / (1000 * 3600 * 24)
    );
    return diffDays;
  }

  bookingDetails(item: any) {
    // let data = {
    //   title: "Bookings Details",
    //   ref: this._modelRef,
    //   data: item,
    // } 
    // this.dialogService.openFullScreenDialog(BookingDetailsComponent,data);

  this.router.navigate(['booking-details'],{relativeTo:this.route, queryParamsHandling: 'merge', queryParams: {bookingHash: item.hash_id}})
  }

  confirmBooking(item: any) {
    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
        ),
        appointmentHash: item.hash_id,
        bookingStatus: 5,
        startTime: item.bookingStartTime.slice(0, 5),
        endTime: item.bookingEndTime.slice(0, 5),
        entityHash: item.entityHash,
        countryCode: item.country_code,
        customerPh: item.customerInfo.phone,
        customerName: item.customerInfo.name,
        price: item.price,
        bookingDate: item.bookingDate,
        note: item.note,
        bookingType: item.bookingType,
        customerHash: item.customerInfo.hash_id,
      },
    };

    console.log(data);
    this.loaderservice.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  cancelBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to cancel this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let notedialogref = this.dialog.open(CancelBookingNotesModalComponent, {
          width: "600px",
          data: {
            title: "Cancel Booking",
          },
        });
        notedialogref.afterClosed().subscribe((res) => {
          if (res) {
            let data = {
              bookingStatusInfo: {
                bookingStatus: 8,
                assignedToHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                assignedByHash: localStorage.getItem(
                  SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID
                ),
                appointmentHash: item.hash_id,
                startTime: item.bookingStartTime.slice(0, 5),
                endTime: item.bookingEndTime.slice(0, 5),
                entityHash: item.entityHash,
                countryCode: item.country_code,
                customerPh: item.customerInfo.phone,
                customerName: item.customerInfo.name,
                price: item.price,
                bookingDate: item.bookingDate,
                note: item.note,
                cancellationNotes: res.notes,
                bookingType: item.bookingType,
                customerHash: item.customerInfo.hash_id,
              },
            };

            console.log(data);
            this.loaderservice.showLoader = true;
            this._apiService.updateBookingStatus(data);
          }
        });
      }
    });
  }

  openInvoice(item: any) {
    let data = {
      title: "Invoice",
      ref: this._modelRef,
      data: item.hash_id,
    } 
    this.dialogService.openFullScreenDialog(InvoiceForReportComponent,data);
  }

 // NEW BUTTONS
   createNewBooking() {
      let data = {
        title: "New Booking",
        ref: this._modelRef,
        data: {
          entityHash: this.entityHashId,
          eph: this.eph,
          // serviceType: this.bookingType,
          discountInfo: this.discountInfo,
          
        }
      };
      

      let dialogref = this.dialogService.openFullScreenDialog(CreateNewBookingFromListComponent, data);
      dialogref.afterClosed().subscribe((res) => {
        if (res) {
             this.changeChip("1");
        }
      });
    }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);
    console.log(curdate);

    return curdate;
  }

  openvideo() {
    this.dialog.open(YoutubeEmbedVideoComponent, {
      width: "1000px",
      disableClose: true,
      data: {
        link: "https://www.youtube.com/embed/y9jYlBqYszM",
        title: "Creating Bookings/Appointments in LookzUp Business Portal. ",
      },
    });
  }

  opencontact() {
    this.router.navigate(["/contact-us"]);
  }
  deleteBooking(item: any) {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message: "Are you sure you want to delete this booking?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        let obj = {
          appointmentHash: item.hash_id,
          entityHash: this.entityHashId,
        };

        this.loaderservice.showLoader = true;
        this._apiService.deleteEntityAppointmentData(obj);
      }
    });
  }

  private newbookingsubscription: Subscription = new Subscription();
  listenForNewBookingUpdates() {
    this.newbookingsubscription = this.notificationService
      .getNotificationByType("newBooking")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              // this.loaderservice.showLoader = true;
              this._apiService.getBookingsList(
                this.entityHashId,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );

            })
          }
        }
      });
  }

  private bookingStatusUpdatedsubscription: Subscription = new Subscription();
  listenForBookingStatusUpdates() {
    this.bookingStatusUpdatedsubscription = this.notificationService
      .getNotificationByType("bookingStatusUpdated")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              this.loaderservice.showLoader = true;
              this._apiService.getBookingsList(
                this.entityHashId,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
              
            })
          }
        }
      });
  }
  private bookingAssignmentsubscription: Subscription = new Subscription();
  listenForBookingAssignmentUpdates() {
    this.bookingAssignmentsubscription = this.notificationService
      .getNotificationByType("onCustomerAssign")
      .subscribe((payload) => {
        if (true) {
          console.log("New notification received:", payload);
          // payload.data.misc = typeof payload.data.misc == 'string' ? JSON.parse(payload.data.misc) : payload.data.misc
          if (
            payload.data.misc.entityHash == this.entityHashId ||
            payload.data.misc.entityHash == this.eph
          ) {
            this.zone.run(() => {
              const title = payload.data.title;
              const message = payload.data.message;
              this.loaderservice.showLoader = true;
              this._apiService.getBookingsList(
                this.entityHashId,
                this.formatDate1(this.fromDate),
                this.formatDate1(this.toDate)
              );
              const snackBarRef = this._snackBar.openFromComponent(
                CustomSnackbarComponent,
                {
                  duration: 5000, // Adjust duration as needed
                  horizontalPosition: "center",
                  verticalPosition: "top",
                  data: { title, message },
                  panelClass: "custom-class1",
                }
              );
              
            })
          }
        }
      });
  }
  openLink(url: string): void {
    window.open(url, "_blank");
  }


   selectedValue: any = "1";
  pageNo: number = 1;
  changeChip(value: any) {
        this.messageList = this.queryData = this.interestData = []
    this.loaderservice.showLoader = true;
    this.visible = false;
    this.loader = true
    this.selectedValue = value;
    if (this.selectedValue == "1") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.toDate.setDate(this.fromDate.getDate() + 90);
      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    } else if (this.selectedValue == "2") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);

      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    } else if (this.selectedValue == "3") {
      this.fromDate = new Date();
      this.toDate = new Date();
      this.fromDate.setDate(this.fromDate.getDate() - 90);
      this._apiService.getBillDiscountData(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID)
      );
    }
  }

   getServiceNames(services: any) {
    console.log(services);

    return services.map((service: any) => service.service_name).join(", ");
  }

  formatTime1(time: string): string {
    const [hour, minute] = time.split(":").map(Number);
    const period = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12; // Convert 0 or 12 to 12 for AM/PM time
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${period}`;
  }

  formatTimeForBooking(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  getWeekdayString(weekday: number): string {
    const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return weekdays[weekday - 1]; // Adjusting because weekday starts from 1
  }

  formatSchedule(schedule: any[]): string {
    return schedule
      .map((item) => {
        const weekday = this.getWeekdayString(item.weekday);
        const startTime = this.formatTime1(item.start_time);
        const endTime = this.formatTime1(item.end_time);
        return `${weekday}: ${startTime} - ${endTime}`;
      })
      .join(", ");
  }


    viewDetails(item: any) {
    // this.loaderservice.showLoader = true;
    // let data = {
    //   data: item,
    // } 
    // this.dialogService.openFullScreenDialog(JoiningInterestDetailsComponent,data);

    
    this.router.navigate(['query-details'],{relativeTo:this.route, queryParamsHandling: 'merge', queryParams:{queryHash:item.hash_id}})


  }

    viewDetailsforservicequery(item: any) {
    // this.loaderservice.showLoader = true
    // this.dialog.open(JoiningInterestDetailsComponent,{
    //   width:'600px',
    //   disableClose:true,
    //   data: {
    //     data: item
    //   }
    // })
    this.router.navigate(["service-query-details"], {
      relativeTo: this.route,
      queryParamsHandling: "merge",
      queryParams: { queryHash: item.hash_id, serviceType: '3' },
    });
  }

  addNewInterestFromList() {
    let data = {
      entityHash: this.entityHashId,
      eph: this.eph,
      // serviceType: this.interestType,
    };

    let obj = {
      title: "New query",
      ref: this.dialog,
      data: data,

    }
    let dialogref = this.dialogService.openFullScreenDialog(AddJoiningInterestFromListComponent,obj);
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.changeChip('2')
      }
    });
  }

}
